export const REQUEST_METHOD = "REQUEST_METHOD";

export const SUCCESS_CATEGORY_METHOD = "SUCCESS_CATEGORY_METHOD";

export const SUCCESS_PRODUCT_METHOD = "SUCCESS_PRODUCT_METHOD";

export const SUCCESS_HOME_DATA_METHOD = "SUCCESS_HOME_DATA_METHOD";

export const SUCCESS_APPEND_METHOD = "SUCCESS_PRODUCT_METHOD";

export const SUCCESS_FILTER_METHOD = "SUCCESS_FILTER_METHOD";

export const SUCCESS_MANUFACTURER_METHOD = "SUCCESS_MANUFACTURER_METHOD";

export const SUCCESS_SORT_H2L_METHOD = "SUCCESS_SORT_H2L_METHOD";

export const SUCCESS_SORT_L2H_METHOD = "SUCCESS_SORT_L2H_METHOD";

export const SUCCESS_DISCOUNT_METHOD = "SUCCESS_DISCOUNT_METHOD";

export const SUCCESS_SINGLE_PRODUCT_METHOD = "SUCCESS_SINGLE_PRODUCT_METHOD";

export const FAILURE_METHOD = "FAILURE_METHOD";
